import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface RewardsHeroProps {
  stars: number;
}

export default function RewardsHero({ stars }: RewardsHeroProps) {
  return (
    <div className="stars-hero-bg px-5 pt-12 pb-6 text-center relative overflow-hidden">
      {/* Decorative stars */}
      <div className="absolute top-4 left-6 text-gold/20 text-4xl select-none">★</div>
      <div className="absolute top-8 right-8 text-gold/15 text-2xl select-none">★</div>
      <div className="absolute bottom-4 left-12 text-gold/10 text-3xl select-none">★</div>

      <p className="text-white/70 text-sm font-medium mb-1">Merhaba, Ayşe!</p>
      <h1 className="text-white font-bold text-xl mb-4">Gloria Jean's Rewards</h1>

      {/* Stars display */}
      <div className="inline-flex flex-col items-center bg-white/10 backdrop-blur rounded-3xl px-10 py-5 border border-white/20">
        <div className="flex items-center gap-3 mb-1">
          <Icon name="StarIcon" size={32} variant="solid" className="text-gold pulse-gold" />
          <span className="text-white font-black text-5xl font-tabular">{stars}</span>
        </div>
        <p className="text-white/70 text-sm font-medium">Yıldız Bakiyeniz</p>
        <div className="mt-3 flex items-center gap-2 bg-white/10 rounded-full px-3 py-1">
          <span className="text-gold text-xs font-bold">Altın Üye</span>
          <span className="text-white/50 text-xs">·</span>
          <span className="text-white/70 text-xs">Reserve için 260 ★ daha</span>
        </div>
      </div>
    </div>
  );
}